<template>
  <div class="kingscup">
    <div v-if="inGame">
      <h1>Kingscup game</h1>
      <el-popover
        placement="right"
        trigger="manual"
        content="Copied"
        v-model="copied"
      >
        <el-input
          slot="reference"
          style="width:385px"
          placeholder="Please input"
          v-model="gameUrl"
          class="input-with-select"
        >
          <el-button
            @click="copyGameUrl"
            slot="append"
            icon="el-icon-copy-document"
          />
        </el-input>
      </el-popover>
      <div class="controls">
        <a style="margin-right:10px;" class="pointer" @click="join">
          <i class="fas fa-sign-in-alt" /> Join Video
        </a>
        <!-- <a style="margin-right:10px;" class="pointer" @click="publish">
          publish vid
        </a>
        <a style="margin-right:10px;" class="pointer" @click="unpublish">
          unpublish vid
        </a> -->
        <a style="margin-right:10px;" class="pointer" @click="leave">
          <i class="fas fa-sign-out-alt" /> Leave Video
        </a>
        <a
          style="margin-right:10px;"
          class="pointer"
          @click="settingDialog = !settingDialog"
        >
          <i class="fas fa-cog pointer" /> Settings
        </a>
        <!-- <a style="margin-right:10px;" class="pointer" @click="beautify">
          beautify vid
        </a> -->
        <a style="margin-right:10px;" class="pointer" @click="muteLocalAudio">
          <span v-if="!rtc.params.audio">
            <i class="fas fa-volume-mute" /> Unmute
          </span>
          <span v-if="rtc.params.audio">
            <i class="fas fa-volume-off" /> Mute
          </span>
        </a>
        <a style="margin-right:10px;" class="pointer" @click="muteLocalVideo">
          <span v-if="!rtc.params.video">
            <i class="fas fa-video-slash" /> Turn on Video
          </span>
          <span v-if="rtc.params.video">
            <i class="fas fa-video" /> Turn off Video
          </span>
        </a>
        <el-dialog
          title="settings"
          :visible.sync="settingDialog"
          width="300px"
          center
        >
          <div class="config-form">
            <el-select v-model="rtc.params.cameraId" placeholder="Select">
              <el-option
                v-for="item in videos"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-select v-model="rtc.params.microphoneId" placeholder="Select">
              <el-option
                v-for="item in audios"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="settingDialog = false">Cancel</el-button>
            <el-button type="primary" @click="settingDialog = false">
              Confirm
            </el-button>
          </span>
        </el-dialog>
      </div>
      <div class="cardPiles" v-if="Object.keys(kingscup).length > 0">
        <!-- <div class="cardPiles" v-if="false"> -->
        <CardDeck
          :isBack="false"
          :cards="kingscup.new_cards"
          @cardAccepted="cardAccepted"
          @cardRejected="cardRejected"
          @cardSkipped="cardSkipped"
          @hideCard="hideCard"
        />
        <!-- <CardDeck
          :cards="kingscup.new_cards"
          :isBack="true"
          @cardAccepted="cardAccepted"
          @cardRejected="cardRejected"
          @cardSkipped="cardSkipped"
          @hideCard="hideCard"
        /> -->
        <!-- <CardDeck
          :cards="kingscup.drawn_cards"
          :isBack="false"
          :canInteract="false"
        /> -->
      </div>
      <!-- <div class="currentCard">
        <div class="card">{{ card }}</div>
        <div class="">{{ currentCard }}</div>
      </div> -->
      <div class="video-grid" :style="videoGridStyling" style="left:10px;">
        <div class="video-view">
          <div
            id="local_stream"
            :style="`width:${videoWidth}px;height:${videoHeight}px;`"
            class="local_stream video-placeholder"
          />
          <div id="local_video_info" class="video-profile hide" />
          <div id="video_autoplay_local" class="autoplay-fallback hide" />
        </div>
        <div
          v-for="(key, index) in remoteStreamLeftKeys"
          :key="`${key}-${index}`"
          class="video-view"
          :id="`remote_video_panel_${rtc.remoteStreams[key].stream.getId()}`"
          :ref="`remote-${rtc.remoteStreams[key].stream.getId()}`"
        >
          <div class="remote-stream-statuses">
            <!-- {{ rtc.remoteStreams[key].stream.getId() }} -->
            <i
              class="fas fa-volume-mute"
              style="margin-right:10px;"
              v-if="!rtc.remoteStreams[key].audio"
            />
            <i
              class="fas fa-volume-off"
              style="margin-right:10px;"
              v-if="rtc.remoteStreams[key].audio"
            />
            <i
              class="fas fa-video-slash"
              style="margin-right:10px;"
              v-if="!rtc.remoteStreams[key].video"
            />
            <i
              class="fas fa-video"
              style="margin-right:10px;"
              v-if="rtc.remoteStreams[key].video"
            />
          </div>
          <div
            :style="
              `width:${videoWidth}px;height:${videoHeight}px;margin: 0 auto`
            "
            :id="`remote_video_${rtc.remoteStreams[key].stream.getId()}`"
            class="remote_stream video-placeholder"
          />
          <div
            :id="`remote_video_info_${rtc.remoteStreams[key].stream.getId()}`"
            class="video-profile hide"
          />
          <div
            :id="`video_autoplay_${rtc.remoteStreams[key].stream.getId()}`"
            class="autoplay-fallback hide"
          />
        </div>
      </div>
      <div class="video-grid" :style="videoGridStyling" style="right:10px;">
        <div
          v-for="(key, index) in remoteStreamRightKeys"
          :key="`${key}-${index}`"
          class="video-view"
          :id="`remote_video_panel_${rtc.remoteStreams[key].stream.getId()}`"
          :ref="`remote-${rtc.remoteStreams[key].stream.getId()}`"
        >
          <div class="remote-stream-statuses">
            {{ rtc.remoteStreams[key].stream.getId() }}
            <i
              class="fas fa-volume-mute"
              style="margin-right:10px;"
              v-if="!rtc.remoteStreams[key].audio"
            />
            <i
              class="fas fa-volume-off"
              style="margin-right:10px;"
              v-if="rtc.remoteStreams[key].audio"
            />
            <i
              class="fas fa-video-slash"
              style="margin-right:10px;"
              v-if="!rtc.remoteStreams[key].video"
            />
            <i
              class="fas fa-video"
              style="margin-right:10px;"
              v-if="rtc.remoteStreams[key].video"
            />
          </div>
          <div
            :style="
              `width:${videoWidth}px;height:${videoHeight}px;margin: 0 auto`
            "
            :id="`remote_video_${rtc.remoteStreams[key].stream.getId()}`"
            class="remote_stream video-placeholder"
          />
          <div
            :id="`remote_video_info_${rtc.remoteStreams[key].stream.getId()}`"
            class="video-profile hide"
          />
          <div
            :id="`video_autoplay_${rtc.remoteStreams[key].stream.getId()}`"
            class="autoplay-fallback hide"
          />
        </div>
      </div>
    </div>
    <div v-if="!inGame">
      <div @click="joinGame(gameId)">Join</div>
    </div>
  </div>
</template>

<script>
import { Socket, Presence } from "phoenix";
// import axios from "axios";
import { mapState } from "vuex";
import kingscup from "@/mixins/kingscup";
import CardDeck from "@/components/CardDeck.vue";
import agora from "@/mixins/agora";
import size from "@/mixins/size";
export default {
  name: "KingscupGame",
  mixins: [kingscup, agora, size],
  components: { CardDeck },
  data() {
    return {
      kingscup: {},
      inGame: true,
      gameId: this.$route.params.gameId,
      channel: null,
      presences: null,
      players: [],
      error: null,
      copied: false,
      settingDialog: false
    };
  },
  computed: {
    ...mapState("user", ["user", "token"]),
    gameUrl() {
      return `${window.location.href}`;
    }
  },
  methods: {
    drawCard() {
      this.channel.push("draw_card");
    },
    joinChannel() {
      const { token, gameId } = this;
      let wsURL =
        process.env.NODE_ENV == "development"
          ? `ws://localhost:4000/socket`
          : `wss://whenshitbreaks.com/socket`;
      const socket = new Socket(wsURL, {
        params: { Authorization: token }
      });

      socket.connect();

      this.channel = socket.channel(`kingscup:${gameId}`, {});

      this.presences = {};

      this.channel.on("presence_state", state => {
        this.presences = Presence.syncState(this.presences, state);
        this.players = this.toPlayers(this.presences);
      });

      this.channel.on("presence_diff", diff => {
        this.presences = Presence.syncDiff(this.presences, diff);
        this.players = this.toPlayers(this.presences);
      });

      this.channel.on("draw_card", kingscup => {
        this.$set(this, "kingscup", kingscup);
      });

      this.channel
        .join()
        .receive("ok", kingscup => {
          this.$set(this, "kingscup", kingscup);
          this.inGame = true;
          // console.log(`Joined ${gameId} 😊: ${kingscup}`);
        })
        .receive("error", response => {
          if (response.reason == "unauthorized") {
            this.inGame = false;
          }
          this.error = `Joining ${gameId} failed 🙁`;
          // console.log(this.error, response);
        });
    },
    toPlayers(presences) {
      const listBy = (name, { metas }) => {
        // console.log(name);
        // console.log(metas);
        return { name, metas };
      };
      return Presence.list(presences, listBy);
    },
    cardAccepted() {
      console.log("cardAccepted");
    },
    cardRejected() {
      console.log("cardRejected");
    },
    cardSkipped() {
      console.log("cardSkipped");
    },
    hideCard() {
      console.log("hideCard");
      this.drawCard();
    },
    copyGameUrl() {
      this.$copyText(this.gameUrl).then(() => {
        this.copied = true;
        setInterval(() => (this.copied = false), 3000);
      });
    }
  },
  created() {
    this.joinChannel();
  }
};
</script>
<style lang="scss">
.kingscup {
  .cardPiles {
    display: flex;
    justify-content: center;
  }
  .video-view {
    position: relative;
    margin-bottom: 10px;
    display: flex;
    justify-content: center;
  }
  .remote-stream-statuses {
    position: absolute;
    bottom: 10px;
    color: white;
    z-index: 1000;
    display: flex;
    justify-content: center;
    width: 100%;
  }
  .local_stream,
  .remote_stream {
    // margin-bottom: 10px;
    border-radius: 5px;
    > div {
      border-radius: 10px;
    }
  }
  .controls {
    z-index: 1000;
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 10px;
    width: 100%;
  }
  .config-form {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  // .currentCard {
  //   width: 33%;
  //   margin-left: 33%;
  //   position: absolute;
  //   bottom: 50px;
  //   display: flex;
  //   .card {
  //     font-size: 22rem;
  //   }
  // }
}
</style>
